<template>
  <div class="py-2 left-bar-profile flex-row bd-highlight mb-3">
    <div class="modal-right">
      <div class="modal-right-header d-flex justify-content-between">
        <div class="details-name">
          <h3>{{ user.firstName }} {{ user.lastName }}</h3>
        </div>
      </div>
      <div class="address-small">
        <i class="fa fa-envelope"></i>
        {{ user.email }}
      </div>
      <div v-if="phone" class="address-small">
        <i class="fas fa-mobile-alt"></i>
        {{ phone }}
      </div>
      <div class="group-structure">
        <div class="group-structure-heading" v-if="structure.length > 0">
          <h4>{{ $t("planing.advanceFilter.structure") }}</h4>
          <p v-for="(st, index) in structure" :key="index">{{ st.name }}</p>
        </div>
      </div>

      <div class="group-structure">
        <div class="group-structure-heading" v-if="group.length > 0">
          <h4>{{ $t("planing.advanceFilter.groups") }}</h4>
          <p>{{ group[0].name }}</p>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import groups from '@/data/groups/Groups';

export default {
  props: ['users', 'userId'],

  data() {
    return {
      groups,
      phone: '',
    };
  },

  computed: {
    user() {
      this.getPhoneNumber(this.userId);
      return this.users.find(u => u.reference == this.userId);
    },

    group() {
      return this.groups.filter(group => group.reference == this.user.permissions[0].groupReference);
    },

    structure() {
      return this.$store.state.structure.list.filter(structure => structure.reference == this.user.structureReference);
    },
  },

  methods: {
    closeDetailsPanel() {
      this.detailPanel = false;
    },

    getPhoneNumber(reference) {
      let phone;
      this.$services.user.getPhoneNo(reference).then((res) => {
        this.phone = res.data.phone;
      });
    },
  },
};
</script>
<style  lang="scss">
.group-structure {
  border-top: 1px solid #ddd;
  width: 100%;
}
.group-structure-heading {
  padding-top: 10px;
  padding-left: 20px;
  padding-right: 20px;
  h4 {
    font-size: 17px;
    padding: 0px;
    margin: 0px;
    text-transform: uppercase;
  }
  p {
    padding: 0px;
    margin: 0px;
    padding-bottom: 5px;
  }
}
.modal-right {
  // position: absolute;
  background-color: #fff;
  width: 300px;
  padding: 20px 0 15px 0;
  box-shadow: 0 10px 25px 0 rgba(128, 128, 128, 0.27);
  left: 20px;
  top: -10px;
  position: relative;
  &:after {
    content: "";
    width: 0px;
    height: 0px;
    border-top: 10px solid transparent;
    border-bottom: 10px solid transparent;
    border-right: 10px solid #fff;
    position: absolute;
    left: -10px;
    top: 7px;
    @media (max-width: 767px) {
      display: none;
    }
  }
  .modal-right-header {
    padding: 0 20px;
  }
  .details-name {
    h3 {
      font-size: 16px;
      margin: 0;
      font-weight: 700;
    }
  }
  .btn-light-color {
    background-color: #f1f2f3;
    border: 0;
    padding: 4px 8px;
    outline: none;
    border-radius: 2px;
    border: 1px solid #ddd;
    display: inline-block;
    i {
      color: gray;
    }
  }
  .address-small {
    margin-bottom: 5px;
    padding: 0 20px;
  }
  .allowances-content {
    margin-top: 20px;
    border-top: 1px solid #ddd;
    border-bottom: 1px solid #ddd;
    padding: 10px 20px;
    h4 {
      margin: 0;
      font-size: 17px;
      text-transform: uppercase;
    }
  }
  .allowances-select {
    width: 80px;
  }
}
</style>
